import React from "react";
import TotalCourses from "../components/pages/Dashboard/TotalCourses";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const TotalCoursesLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <TotalCourses />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default TotalCoursesLayout;